/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCreditCard, faCircleNotch } from '@fortawesome/pro-solid-svg-icons';
import { useStorageAccountInfo, useStoragePaymentHistory } from './queries';
import {
  usdFormatter,
  formatDate,
  getCreditCardIssuerInfo,
} from '../../../lib/helpers';

function StoragePayments() {
  const { data: accountInfoData } = useStorageAccountInfo();
  const { data: accountPaymentHistory } = useStoragePaymentHistory();
  const queryStatus = useQuery(['storageAccountInfo']);
  const [lastPaymentDate, setLastPaymentDate] = useState(null);

  // Use the most recent payment (non-invoice) transaction to
  // determine the most recent payment date
  useEffect(() => {
    if (accountPaymentHistory) {
      const payments = accountPaymentHistory.filter(
        ({ isInvoice }) => !isInvoice
      );
      if (payments.length) {
        setLastPaymentDate(payments[0].date);
      }
    }
  }, [accountPaymentHistory]);

  const userCard = accountInfoData?.creditCard;
  let cardIcon = null;
  if (userCard) {
    cardIcon = getCreditCardIssuerInfo(userCard.cardType).display;
  }

  let balanceLabel = 'Balance';
  let balanceVal = null;

  if (accountInfoData) {
    const { currentBalance } = accountInfoData;

    balanceVal = currentBalance;
    if (currentBalance.startsWith('-')) {
      balanceLabel = 'Credit Balance';
      balanceVal = balanceVal.slice(1); // Strip off the negative sign
    }
  }

  if (!queryStatus.isFetching && accountInfoData.noStorageAccount) {
    return (
      <div className="portal-inner">
        <Row>
          <Col md={8} lg={7} xl={5}>
            <div className="info-box">
              <div className="info-content">No storage records on file.</div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  console.log('aid>', accountInfoData);

  return (
    <div className="portal-inner has-tabs">
      <Row>
        <Col md={8} lg={7} xl={5}>
          <div className="info-box">
            <div className="info-header">
              <h3>Payment Info</h3>
              <FontAwesomeIcon icon={faCreditCard} />
            </div>
            <div className="info-content">
              {!queryStatus.isFetching ? (
                <>
                  <div className="group">
                    <label>Contact</label>
                    <div>
                      <strong>{accountInfoData.email}</strong>
                      <br />
                      {accountInfoData.phoneNumber}
                    </div>
                  </div>
                  <div className="group">
                    <label>Payment</label>
                    <Row>
                      <Col md={8}>
                        {userCard.cardMasked ? (
                          <p>
                            <span className="credit-cards pe-1">
                              <FontAwesomeIcon icon={cardIcon} size="2x" />
                            </span>
                            **** **** **** {userCard.cardMasked}
                          </p>
                        ) : (
                          <p>No credit card on file.</p>
                        )}
                      </Col>
                      <Col md={4} className="text-right">
                        <Link
                          to="/portal/storage/payments/update-payment"
                          className="small"
                        >
                          update payment
                        </Link>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={8}>
                        {userCard.firstName &&
                          userCard.lastName &&
                          userCard.city &&
                          userCard.state &&
                          userCard.zipCode && (
                            <div className="line-height-base">
                              {`${userCard.firstName} ${userCard.lastName}`}
                              <br />
                              {userCard.address1}
                              <br />
                              {userCard.address2}
                              <br />
                              {`${userCard.city}, ${userCard.state} ${userCard.zipCode}`}
                            </div>
                          )}
                      </Col>
                    </Row>
                  </div>
                  <div className="group">
                    {balanceVal !== null && (
                      <>
                        <label>{balanceLabel}</label>
                        <Row>
                          <Col md={8}>
                            <div className="h3 no-margin text-body">
                              {usdFormatter.format(balanceVal)}
                            </div>
                          </Col>
                        </Row>
                      </>
                    )}
                    <Row>
                      <Col md={8}>
                        {lastPaymentDate && (
                          <>Last payment on: {formatDate(lastPaymentDate)}</>
                        )}
                      </Col>
                      <Col md={4} className="text-right">
                        <Link
                          to="/portal/storage/payments/view-history"
                          className="small"
                        >
                          view history
                        </Link>
                      </Col>
                    </Row>
                    {accountInfoData?.nextBillingDate && (
                      <Row className="my-2">
                        <Col md={12}>
                          Next billing date:{' '}
                          {formatDate(accountInfoData.nextBillingDate)}
                        </Col>
                      </Row>
                    )}
                  </div>
                </>
              ) : (
                <div className="text-center py-5">
                  <FontAwesomeIcon
                    icon={faCircleNotch}
                    spin
                    size="3x"
                    style={{ color: '#953263' }}
                  />
                </div>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default StoragePayments;
